import React, { useState } from "react";
import { IOrganization } from "../../../redux/types/UserTypes";
import { useAppDispatch } from "../../../hooks/ReduxHooks";
import { onOrganizationSelect } from "../../../redux/requests/IdentificationRequests";

interface IOrganizationSelectorProps {
  organizations: IOrganization[];
  onSelect?: (org: IOrganization) => void;
}

const OrganizationSelector: React.FC<IOrganizationSelectorProps> = ({
  organizations,
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const dispatch = useAppDispatch();

  const handleSelect = (org: IOrganization) => {
    setSelectedId(org.ein);
    dispatch(onOrganizationSelect(org));
  };

  return (
    <div className="flex flex-col gap-4">
      <h1 className="font-bold text-lg">Выберите организацию</h1>
      {organizations.map((org) => {
        const isSelected = selectedId === org.ein;

        return (
          <div
            key={org.ein}
            onClick={() => handleSelect(org)}
            className={`
              cursor-pointer border rounded-2xl p-4 shadow-sm transition
              hover:shadow-md
              ${isSelected ? "border-blue-500 bg-blue-50" : "border-gray-200"}
            `}
          >
            <h3 className="text-md font-semibold">{org.FullName}</h3>
            {org.ein && (
              <p className="text-sm text-gray-500 mt-1">ЕИН: {org.ein}</p>
            )}
            {org.inn && (
              <p className="text-sm text-gray-500 mt-1">ИНН: {org.inn}</p>
            )}

            {isSelected && (
              <div className="mt-3 text-blue-600 text-sm font-medium">
                Выбрано
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OrganizationSelector;
